/**
 * ArcSummary entity schema
 */

import { z } from 'zod';
import { ArcStatusSchema } from '../enums';

export const ArcSummarySchema = z.object({
  id: z.string(),
  world_id: z.string(),
  arc_number: z.number().int().positive(),
  title: z.string().nullable(),
  summary: z.string(),
  themes: z.array(z.string()).nullable(),
  status: ArcStatusSchema,
  started_at: z.string(),
  completed_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type ArcSummary = z.infer<typeof ArcSummarySchema>;
